<template>
    <div class="teamwork">
         <div class="teamwork_back">
             <div class="go_back" @click="back"></div>
         </div>
         <div class="teamwork_explian">
             <div class="xjzm_ico">
                 <img src="/static/images/xjzm.png">
             </div>
             <div class="company">
                 杭州寻匠之美网络科技有限公司
             </div>
             <div class="contact">
                 联系我们
             </div>
             <div class="cause">
                 如果你能生产出质优价美的好货，请联系我们
             </div>
             <div class="cause">
                 如果你有强大的产品研发创新能力，请联系我们
             </div>
             <div class="cause">
                 如果您手上有品牌好货，请联系我们
             </div>   
             <div class="cause">
                 如果您想成为寻匠之美的渠道分销商，请联系我们
             </div>    
             <div class="cause">
                 联系邮箱：business@efifan.cn
             </div>                                 
         </div>
        <div class="teamwork_foot">
            <div class="slogan">用善良的力量让世界变得更美好</div>
            <div class="welcome">
                <span class="line"></span>
                <span class="txt">购好货 来寻匠之美</span>
                <span class="line"></span>
            </div> 
        </div>           
    </div>          
</template>
<script>
    export default {
        name: 'Teamwork',
        data () {
             return {

             }
        },
        created(){
            document.title="招商合作";
        },
        methods:{
            back(){
                this.$router.go(-1);
            }
        },
    }
</script>
<style  scoped>
.teamwork{position: relative;width:100%;height:100%;background:#F8F8F8;}
.teamwork_back{width:100%;height:80px;padding-top:20px;}
.go_back{width:48px;height:28px;background:url("/static/images/team_go_back.png") no-repeat center center;background-size:100% 100%;padding-top:20px;margin-left:12px; }
.xjzm_ico{width:140px;height:140px;position:absolute;left: 50%;margin-left: -70px;top:-70px;}
.xjzm_ico img{width:100%;height:100%;border-radius:50%;}
.teamwork_explian{width:100%;border-radius:40px 40px 0 0;background:#FFF;position: relative;}
.company{color:#9B9B9B;font-size:28px;text-align: center;padding-top:88px;}
.contact{color:#000000;font-size:28px;text-align: center;font-weight:bold;margin-top:14px;margin-bottom:50px;}
.cause{width:698px;margin:0 auto;height:90px;border-bottom:1px solid #F8F8F8;line-height:90px;font-size:28px;color:#333334;}
.teamwork_foot{width:100%;height:128px;position: fixed;bottom:0;text-align: center;}
.slogan{color:#333334;font-size:28px;}
.welcome{height:90px;line-height: 90px;text-align: center;}
.welcome .line {
   display: inline-block;
   vertical-align: middle;
   width: 40px;
   border-top: 2px solid #C6C6C6;
}
.welcome .txt {
   color: #9B9B9B;
   padding:0 16px;
   font-size:24px;
   vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/person/teamwork.vue